"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_CoverageEligibilityResponse_Item = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_CoverageEligibilityResponse_Benefit_1 = require("./RTTI_CoverageEligibilityResponse_Benefit");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
exports.RTTI_CoverageEligibilityResponse_Item = t.recursion('ICoverageEligibilityResponse_Item', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        category: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        productOrService: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        modifier: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
        provider: RTTI_Reference_1.RTTI_Reference,
        excluded: t.boolean,
        _excluded: RTTI_Element_1.RTTI_Element,
        name: t.string,
        _name: RTTI_Element_1.RTTI_Element,
        description: t.string,
        _description: RTTI_Element_1.RTTI_Element,
        network: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        unit: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        term: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        benefit: t.array(RTTI_CoverageEligibilityResponse_Benefit_1.RTTI_CoverageEligibilityResponse_Benefit),
        authorizationRequired: t.boolean,
        _authorizationRequired: RTTI_Element_1.RTTI_Element,
        authorizationSupporting: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
        authorizationUrl: RTTI_uri_1.RTTI_uri,
        _authorizationUrl: RTTI_Element_1.RTTI_Element
    });
});
//# sourceMappingURL=RTTI_CoverageEligibilityResponse_Item.js.map